// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M5qwnx7BykQp68Uf7WuT{flex-direction:column;gap:20px;width:180px;display:flex}.TQKCILZgxJADHs34deqO{color:var(--green-70)}.sm78iGCHUEp2uxWk8ZXT{color:var(--content-primary-tertiary)}.W3ahPU2mhKoAfu1lGYEZ{border:1px solid var(--border-neutral-default);border-radius:12px;justify-content:flex-start;align-items:center;gap:8px;padding:12px;text-decoration:none;display:flex}.W3ahPU2mhKoAfu1lGYEZ:hover{border:1px solid var(--interaction-neutral-hovered)}.W3ahPU2mhKoAfu1lGYEZ .y2LyGIl3UA4BKlDGhDOm{background:var(--background-neutral-default);border-radius:6px;justify-content:center;align-items:center;gap:8px;padding:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `M5qwnx7BykQp68Uf7WuT`,
	"requiredVerificationTitle": `TQKCILZgxJADHs34deqO`,
	"verificationTitle": `sm78iGCHUEp2uxWk8ZXT`,
	"button": `W3ahPU2mhKoAfu1lGYEZ`,
	"iconWrap": `y2LyGIl3UA4BKlDGhDOm`
};
export default ___CSS_LOADER_EXPORT___;
